import { POST, GET } from '@/utils/request'
import Api from './url'

export const getMainData = async (params: object) => {
  return await GET({
    url: Api.getMainData,
    params,
    showError: false
  })
}
export const getTimesData = async (params: object) => {
  return await GET({
    url: Api.getTimesData,
    params,
    showError: false
  })
}
export const signIn = async (params: object) => {
  return await GET({
    url: Api.signIn,
    params,
    showError: false
  })
}
export const getStarOverview = async (params: object) => {
  return await GET({
    url: Api.getStarOverview,
    params,
    showError: false
  })
}
